module.exports = __webpack_public_path__ + "media/images/instagram-tooltip-66c394a55d25da9d3c2d9690adab4cfb.png";